import React, { Component } from "react";

import "./index.scss";

import terms from "../../assets/documents/termos-de-uso.pdf";

class TermsOfUse extends Component {
  render() {
    return (
      <div style={{ height: "100vh", overflowY: "hidden" }}>
        <iframe src={terms} height="100%" width="100%" />
      </div>
    );
  }
}

export default TermsOfUse;
